import {
  IMAGE_ACTION,
  IMAGE_ASPECT_RATIOS,
  IMAGE_MODE,
  IMAGE_MODEL_ID,
  PROVIDER,
} from 'Pods/ThreeDStudio/Store/constants'

export default {
  "model_id": IMAGE_MODEL_ID.NANO_BANANA_MULTI_IMAGE_EDIT_NB2_LITE,
  "provider": PROVIDER.NANO_BANANA,
  "action": IMAGE_ACTION.MULTI_IMAGE_EDIT,
  "mode": IMAGE_MODE.NB2_LITE,
  "input_schema": {
    "type": "object",
    "properties": {
      "prompt": {
        "type": "string",
        "minLength": 1,
      },
      // Images are read by position. With overlay_mask the backend caps the list at two:
      // image 1 is the base and image 2 the red overlay marking the regions to edit.
      "input_image": {
        "type": "array",
        "minItems": 2,
        "maxItems": 14,
        "items": {
          "type": "object",
          "properties": { "asset_id": { "type": "integer" } },
          "required": ["asset_id"],
        },
      },
      "overlay_mask": {
        "type": "boolean",
      },
      "aspect_ratio": {
        "type": "string",
        "enum": IMAGE_ASPECT_RATIOS,
      },
      "num_images": {
        "type": "integer",
        "minimum": 1,
        "maximum": 4,
      },
    },
    "required": ["prompt", "input_image"],
  },
  "ui_schema": {},
}
